import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';


// Weather Component
const Weather = ( darkMode) => {
  const [city, setCity] = useState('Bilar'); // Default city to Bilar
  const [weatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_KEY = '673d2cacc1625fb59b2837876ef14dbf';
  const BASE_URL = 'http://api.openweathermap.org/data/2.5/weather';

  useEffect(() => {
    const fetchWeather = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(BASE_URL, {
          params: {
            q: city, // City name (Bilar)
            appid: API_KEY, // Your API key
            units: 'metric', // Temperature in Celsius
          },
        });
        setWeatherData(response.data); // Set the weather data from the response
      } catch (err) {
        setError('Error fetching weather data');
      }
      setLoading(false);
    };

    fetchWeather();
  }, [city]); // Trigger this when the city changes

  return (
    <WeatherContainer darkMode={darkMode}>
      <CityInput
        type="text"
        value={city}
        onChange={(e) => setCity(e.target.value)} // Update city
        placeholder="Enter city name"
      />
      {loading && <Loading>Loading...</Loading>}
      {error && <Error>{error}</Error>}
      {weatherData && !loading && !error && (
        <WeatherCard>
          <Title>Today</Title>
          <WeatherIcon>
            <img
              src={`http://openweathermap.org/img/wn/${weatherData.weather[0].icon}.png`}
              alt={weatherData.weather[0].description}
            />
          </WeatherIcon>
          <Temp>{weatherData.main.temp}°C</Temp>
          <Description>{weatherData.weather[0].description}</Description>
          <AdditionalInfo>
            <p>Humidity: {weatherData.main.humidity}%</p>
            <p>Wind Speed: {weatherData.wind.speed} m/s</p>
          </AdditionalInfo>
        </WeatherCard>
      )}
    </WeatherContainer>
  );
};

// Styled Components
const WeatherContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: .75%;
  width: 93%;
  margin-right: 14%;
  align-items: center;
  border-radius: 10px;
  min-height: 20vh;
  font-family: Arial, sans-serif;
  background: linear-gradient(45deg,rgb(21, 182, 21),rgb(176, 238, 75));
  color: #333;

`;

const Header = styled.h1`
  font-size: 1rem;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
`;

const CityInput = styled.input`
  padding: 1px;
  font-size: 1rem;
  width: 10 0px;
  margin-top: -10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  text-align: center;
  transition: all 0.3s ease-in-out;
  :focus {
    outline: none;
    border-color: #0077b6;
  }
`;

const Loading = styled.p`
  font-size: 1rem;
  color:rgb(243, 255, 76);
  font-weight: bold;
`;

const Error = styled.p`
  font-size: 1rem;
  color: #ff4c4c;
  font-weight: bold;
`;

const WeatherCard = styled.div`
  display: flex;
  flex-direction: column;  
  align-items: center;
  justify-content: center;
  position: relative;
  width: 280px;
  height: 120px;  
  color: white;
  border-radius: 10px;
  padding: 20px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(191, 224, 99, 0.1);
  :hover {
     background: linear-gradient(45deg,rgb(21, 182, 120),rgb(176, 238, 75));
  }
`;


const Title = styled.h3`
  font-size: 1.3rem;
  text-align: center;
  font-weight: bold;
    margin-bottom: -18px;
`;

const WeatherIcon = styled.div`
  display: flex;
  margin: 0px 0;
 margin-bottom: -17px;
   margin-right: 10px;
  img {
    width: 100px;
    height: 100px;
  }
`;

const Temp = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 5px;
    margin-right: 10px;
  color: #0077b6;
`;

const Description = styled.div`
  font-size: 1.2rem;
  text-transform: capitalize;
  text-align: center;
  margin-bottom: 30px;
  margin-right: 10px;
`;

const AdditionalInfo = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 0.9rem;
  p {
    margin: 5px 0;
     margin-left: 200px;
  }
`;

export default Weather;
